import { render } from "./aIcon.vue?vue&type=template&id=338bf76e"
import script from "./aIcon.vue?vue&type=script&lang=js"
export * from "./aIcon.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__